import { V2_MATERIAL_VARS } from '@app/modules/client-v2/shell/v2-theme'

// Admin + Reseller v2 reskin (Epic L30-2211). AdminComponent and ResellerComponent call these on
// mount/destroy. `body.ui-v2-admin` scopes the non-Material v2 skin (src/styles/_admin-v2.scss);
// V2_MATERIAL_VARS applied inline on <html> recolours the existing Material M2 theme purple -> v2
// blue (same source/mechanism as the client v2 shell). Removed on destroy so the legacy v1 client
// shell (/client/*), which shares app.component chrome, is left completely untouched.
const ADMIN_BODY_CLASS = 'ui-v2-admin'

// The admin and reseller areas both wear the v2 admin skin. The theme is applied from the URL (by
// AppComponent, before the lazy admin/reseller shell chunk mounts) so the shared v1 chrome never
// paints in its old style first and flashes on a slow load.
export function isV2AdminUrl(url: string | null | undefined): boolean {
  if (!url) return false
  const path = url.split(/[?#]/)[0]
  return /^\/(admin|reseller)(\/|$)/.test(path)
}

export function applyV2AdminTheme(): void {
  const html = document.documentElement
  document.body.classList.add(ADMIN_BODY_CLASS)
  for (const [prop, value] of Object.entries(V2_MATERIAL_VARS)) {
    html.style.setProperty(prop, value)
  }
}

export function clearV2AdminTheme(): void {
  const html = document.documentElement
  document.body.classList.remove(ADMIN_BODY_CLASS)
  for (const prop of Object.keys(V2_MATERIAL_VARS)) {
    html.style.removeProperty(prop)
  }
}
